import gql from "graphql-tag";

export const GET_SUBSCRIPTION_PLAN_LIST = gql`
    query planList($paymentProvider: PaymentProvider) {
        planList(paymentProvider: $paymentProvider) {
            totalCount
            plans {
                stripeId
                paypalId
                interval
                name
                amount
                currency
                paypalStatus
            }
        }
    }
`;
